import fetchWebApi from 'api/fetchWebApi';

export interface PutPasswordPaylaod {
  newPassword: string;
  repeatedPassword: string;
  recovery: true;
}

const putPasswordApiCall = async (payload: PutPasswordPaylaod): Promise<void> =>
  fetchWebApi(`/client/password`, undefined, {
    method: 'put',
    body: JSON.stringify(payload),
  });

export default putPasswordApiCall;
